import { SignatureConstraints } from "client/Api/Email/Signatures/Personal/personalSignatureSettings";
import { environmentHttpClient } from "client/Api/httpClient";
import { FontStyleModel } from "client/Api/common";

export type ManagedSignatureModel = {
	name: string;
	content: string;
	shouldBeInsertedAutomatically: boolean;
};

export type EnvironmentEmailSettingsModel = {
	automaticallyShowSenderImages: boolean;
	defaultComposerFontStyle: FontStyleModel;
	isManagedSignatureEnabled: boolean;
	managedSignature: ManagedSignatureModel;
	signatureConstraints: SignatureConstraints;
};

export type EnvironmentEmailSettingsSaveModel = {
	automaticallyShowSenderImages: boolean;
	defaultComposerFontStyle: FontStyleModel;
	isManagedSignatureEnabled: boolean;
	managedSignature?: ManagedSignatureModel;
};

export function getViewModel(signal?: AbortSignal): Promise<EnvironmentEmailSettingsModel> {
	return environmentHttpClient.get<EnvironmentEmailSettingsModel>(
		"UiApi/EnvironmentEmailSettings",
		undefined,
		{ signal }
	);
}

export const save = (
	model: EnvironmentEmailSettingsSaveModel,
	signal?: AbortSignal
): Promise<void> => {
	return environmentHttpClient.put<void>(
		"UiApi/EnvironmentEmailSettings",
		model,
		{ signal }
	);
};
